import { render, staticRenderFns } from "./LocaleSelectorVuex.vue?vue&type=template&id=e2382d42&"
import script from "./LocaleSelectorVuex.vue?vue&type=script&lang=ts&"
export * from "./LocaleSelectorVuex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports